import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';

const MostSellingCategory = ({ mostSellingCategories = [] }) => {
  // console.log('mostSellingCategories', mostSellingCategories)
  const [chartData, setChartData] = useState({
    series: [],
    options: {}
  });

  useEffect(() => {
    if (mostSellingCategories.length) {
      const totalOrders = mostSellingCategories.reduce((sum, item) => sum + item.orderCount, 0);

      const series = mostSellingCategories.map(item =>
        parseFloat(((item.orderCount)).toFixed(2))
      );

      const labels = mostSellingCategories.map(item => item.name);

      setChartData({
        series,
        options: {
          chart: {
            type: 'donut',
          },
          labels,
          legend: {
            show: false
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            y: {
              // formatter: val => `${val.toFixed(0)}%`
              formatter: val => `${val.toFixed(0)}`
            }
          },
          colors: ['#FF7D6C', '#00BFA6', '#6C63FF', '#FFA500', '#00A3FF'],
        }
      });
    }
  }, [mostSellingCategories]);
  return (
    <div className="col-md-6">
      <div className="card shadow-sm p-4 text-center">
        <h5 className="fw-bold mb-4">Most selling Categories</h5>

        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          width={320}
        />

        <div className="mt-4">
          {mostSellingCategories.map((item, idx) => {
            const total = mostSellingCategories.reduce((sum, item) => sum + item.orderCount, 0);
            const value = (item.orderCount).toFixed(0);
            return (
              <div key={item._id} className="d-flex justify-content-between px-4 py-1">
                <span>{item.name}</span>
                <span>{value}</span> 
              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default MostSellingCategory